var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560 4560 l0 -560 560 0 560 0 0 560 0 560 -560 0 -560 0 0 -560z m960 0 l0 -400 -400 0 -400 0 0 400 0 400 400 0 400 0 0 -400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 3920 l0 -1200 560 0 560 0 0 1200 0 1200 -560 0 -560 0 0 -1200z m960 0 l0 -1040 -400 0 -400 0 0 1040 0 1040 400 0 400 0 0 -1040z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3600 2320 l0 -1800 560 0 560 0 0 1800 0 1800 -560 0 -560 0 0 -1800z m960 0 l0 -1640 -400 0 -400 0 0 1640 0 1640 400 0 400 0 0 -1640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 960 l0 -960 560 0 560 0 0 960 0 960 -560 0 -560 0 0 -960z m960 0 l0 -800 -400 0 -400 0 0 800 0 800 400 0 400 0 0 -800z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.ce30f1744a7cf2910e8838e657cdce3b.svg";
export { ForwardRef as ReactComponent };